import { render, staticRenderFns } from "./horaireForm.vue?vue&type=template&id=488d6c4a&"
import script from "./horaireForm.vue?vue&type=script&lang=js&"
export * from "./horaireForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports